module.exports = "<svg fill=\"#000000\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphcool-styles/icons/fill/check.svg
// module id = 485
// module chunks = 0 1